document.addEventListener('DOMContentLoaded', function() {
    var benefitsNav = document.querySelector('.benefits__nav');
    if (!benefitsNav) return; // Jeśli nawigacja nie istnieje, zakończ skrypt
    var tabs = benefitsNav.querySelectorAll('.benefits__tab');
    var contentContainers = document.querySelectorAll('.benefits__container');
    benefitsNav.addEventListener('click', function(event) {
        var clickedTab = event.target.closest('.benefits__tab');
        if (!clickedTab) return; // Kliknięto poza przyciskiem
        var tabNumber = clickedTab.dataset.tab;
        // Aktualizacja klas dla przycisków (zakładek)
        tabs.forEach(function(tab) {
            tab.classList.remove('active');
            tab.classList.add('passive');
        });
        clickedTab.classList.add('active');
        clickedTab.classList.remove('passive');
        // Pokazywanie/ukrywanie odpowiedniej treści
        contentContainers.forEach(function(container) {
            if (container.dataset.tabContent === tabNumber) container.classList.add('active');
            else container.classList.remove('active');
        });
    });
});

//# sourceMappingURL=Kickstarter.36c673d9.js.map
